import React from 'react';
import PropTypes from 'prop-types';
import { DateTimeInput } from './DateTime';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import { Controller } from 'react-hook-form';
import { isEqual, parseISO } from 'date-fns';

export const ConnectedDateTimeInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    const { id: contextId } = useAutosavingFormContext();

    return (
      <Controller
        name={name}
        rules={{
          required,
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <DateTimeInput
            id={(id ?? contextId) ? `${contextId}.${name}` : name}
            variant='outlined'
            size='small'
            fullWidth
            {...props}
            name={name}
            value={
              !value ||
              value === '' ||
              value === '0001-01-01T00:00:00' ||
              value === '0001-01-01T00:00:00Z' ||
              (typeof value === 'string' &&
                isEqual(parseISO('0001-01-01T00:00:00Z'), parseISO(value)))
                ? ''
                : value
            }
            onChange={(value) => {
              // Handle both synthetic events (typing) and direct values (calendar selection)
              let newValue;
              if (value && typeof value === 'object' && 'target' in value) {
                // Synthetic event from text input
                newValue = value.target.value;
              } else if (value instanceof Date) {
                // Date object from calendar selection
                newValue = value.toISOString();
              } else {
                // Direct string value
                newValue = value;
              }

              if (
                newValue === null ||
                newValue === undefined ||
                newValue === ''
              ) {
                // magic date to represent null date in Encompass
                onChange('0001-01-01T00:00:00Z');
              } else {
                onChange(newValue);
              }
            }}
            onBlur={onBlur}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

export default ConnectedDateTimeInput;

ConnectedDateTimeInput.displayName = 'ConnectedDateTimeInput';

ConnectedDateTimeInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
};
